module.exports = __webpack_public_path__ + "static/media/imagotype_white.a6be17ec.svg";